const Study = () => {
    return (
        <div className="bg-green-light p-3 md:p-6 rounded-md text-left text-[4vw] xsm:text-sm xl:text-base">
            <p className="font-bold">Depression Study</p>

            <p>
                Take part in our trial @King’s College London of a new app and
                video-calls to tackle depression.
            </p>

            <p>
                You are eligible if you are not having active suicidal thoughts,
                bipolar or psychotic symptoms.
            </p>

            <p>
                Please use the pre-screening form linked below if you are
                interested in participating:
            </p>

            <a
                href="https://forms.office.com/e/iNF1Fqu9Zy"
                target="_blank"
                rel="noopener noreferrer"
                className="underline"
            >
                Pre-screening form
            </a>
        </div>
    );
};

export default Study;
